<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-header pb-0">
            <div class="d-flex align-items-center flex-wrap gap-2">
              <h6 class="mb-0 me-auto">Trabajos y Deudas de Operarios</h6>
              <div class="d-flex align-items-center gap-2">
                <button
                  type="button"
                  class="btn btn-sm btn-primary"
                  @click="openCreateModal"
                  title="Agregar Trabajo/Deuda"
                >
                  <i class="fa fa-plus me-1"></i> Agregar
                </button>
                <button class="btn btn-sm btn-success" @click="exportToExcel" title="Exportar a Excel">
                  <i class="fas fa-file-excel me-1"></i> Exportar Excel
                </button>
              </div>
            </div>
          </div>
          <div class="card-body px-0 pt-0 pb-2">
            <!-- Filtros -->
            <div class="px-4 pt-3 pb-2">
              <div class="row g-2">
                <div class="col-md-3">
                  <label class="form-control-label">Usuario</label>
                  <select class="form-select" v-model="filters.user_id" @change="fetchData()">
                    <option value="">Todos</option>
                    <option v-for="user in users" :key="user.id" :value="user.id">{{ user.name }}</option>
                  </select>
                </div>
                <div class="col-md-3">
                  <label class="form-control-label">Estado</label>
                  <select class="form-select" v-model="filters.status" @change="fetchData()">
                    <option value="">Todos</option>
                    <option value="pending">Pendiente</option>
                    <option value="paid">Pagado</option>
                  </select>
                </div>
                <div class="col-md-3">
                  <label class="form-control-label">Fecha desde</label>
                  <input
                    type="date"
                    class="form-control"
                    v-model="filters.start_date"
                    @change="fetchData()"
                  />
                </div>
                <div class="col-md-3">
                  <label class="form-control-label">Fecha hasta</label>
                  <input
                    type="date"
                    class="form-control"
                    v-model="filters.end_date"
                    @change="fetchData()"
                  />
                </div>
                <div class="col-md-12">
                  <label class="form-control-label">Buscar</label>
                  <input type="text" class="form-control" v-model="filters.search" placeholder="Buscar por descripción..." @input="fetchData()" />
                </div>
              </div>
            </div>

            <div class="table-responsive p-0">
              <table class="table align-items-center mb-0">
                <thead>
                  <tr>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Operario</th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Descripción</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Tipo</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Precio Total</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Ganancia Empleado (70%)</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Pagado al empleado</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Estado</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Fecha</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="data && data.length > 0" class="bg-light">
                    <td colspan="4" class="text-end align-middle text-sm font-weight-bold">
                      Total a Pagar (Pendientes):
                    </td>
                    <td class="align-middle text-center text-sm">
                      <h6 class="mb-0 text-sm font-weight-bold text-warning">
                        {{ totalPendingEmployeeEarning.toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}
                      </h6>
                    </td>
                    <td class="align-middle text-center text-sm">
                      <h6 class="mb-0 text-sm font-weight-bold text-success">
                        {{ totalPaidEmployeeEarning.toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}
                      </h6>
                    </td>
                    <td colspan="3" class="align-middle text-center" >
                      <button
                          v-if="pendingTasksCount > 0"
                          type="button"
                          @click="markAllPendingAsPaid"
                          class="btn btn-sm btn-info mb-0"
                          title="Marcar todas las tareas pendientes como pagadas"
                        >
                          <i class="fas fa-check me-1"></i>
                          Marcar todas como pagadas
                        </button>
                    </td>
                  </tr>
                  <tr v-for="task in data" :key="task.id">
                    <td>
                      <div class="d-flex px-2 py-1">
                        <h6 class="mb-0 text-sm">{{ task.user?.name || 'N/A' }}</h6>
                      </div>
                    </td>
                    <td>
                      <div class="d-flex px-2 py-1">
                        <p class="text-xs mb-0" style="max-width: 200px; overflow: hidden; text-overflow: ellipsis;">
                          {{ task.description }}
                        </p>
                      </div>
                    </td>
                    <td class="align-middle text-center text-sm">
                      <span class="badge badge-sm" :class="{
                        'bg-gradient-info': task.type === 'task',
                        'bg-gradient-warning': task.type === 'debt'
                      }">
                        {{ task.type === 'task' ? 'Tarea' : 'Deuda' }}
                      </span>
                    </td>
                    <td class="align-middle text-center text-sm">
                      <h6 class="mb-0 text-sm">
                        {{ parseFloat(task.price ?? 0).toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}
                      </h6>
                    </td>
                    <td class="align-middle text-center text-sm">
                      <h6 class="mb-0 text-sm">
                        {{ employeeEarning(task).toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}
                      </h6>
                    </td>
                    <td class="align-middle text-center text-sm">
                      <h6 class="mb-0 text-sm text-success">
                        {{ parseFloat(task.employee_paid ?? 0).toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}
                      </h6>
                    </td>
                    <td class="align-middle text-center text-sm">
                      <span class="badge badge-sm" :class="{
                        'bg-gradient-warning': task.status === 'pending',
                        'bg-gradient-info': task.status === 'partial',
                        'bg-gradient-success': task.status === 'paid'
                      }">
                        {{
                          task.status === 'pending' ? 'Pendiente' :
                          task.status === 'partial' ? 'Parcial' :
                          task.status === 'paid' ? 'Pagado' : ''
                        }}
                      </span>
                    </td>
                    <td class="align-middle text-center text-sm">
                      <h6 class="mb-0 text-sm">
                        {{ isValidDate(task.task_date) ? new Date(task.task_date).toLocaleDateString('es-ES') : 'Sin fecha' }}
                      </h6>
                    </td>
                    <td class="align-middle text-center">
                      <a
                        v-if="task.status !== 'paid'"
                        @click="markAsPaid(task)"
                        class="text-secondary font-weight-bold text-xs cursor-pointer me-3"
                        title="Marcar como pagado"
                      >
                        <i class="fas fa-check text-secondary"></i>
                      </a>
                      <a
                        v-if="task.status !== 'paid'"
                        @click="deleteTask(task.id)"
                        class="text-secondary font-weight-bold text-xs cursor-pointer"
                        title="Eliminar"
                      >
                        <i class="fas fa-trash text-danger"></i>
                      </a>
                    </td>
                  </tr>
                  <tr v-if="!data || data.length === 0">
                    <td colspan="8" class="text-center text-xxs">No hay registros disponibles</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="pagination p-3">
              <a
                v-for="link in links"
                :key="link.label"
                class="page-item cursor-pointer"
                @click="fetchData(link.label)"
                :disabled="!link.url || link.active"
                :class="{ 'active': link.label === currentPage.toString() }"
              >
                {{ link.label.replace('&laquo;', '«').replace('&raquo;', '»') }}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Swal from 'sweetalert2';
import userService from '@/services/user.service';

const todayDateString = () => {
  const d = new Date();
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
};

export default {
  name: 'WorkerTasksTable',
  data() {
    const today = todayDateString();
    return {
      filters: {
        user_id: '',
        status: '',
        search: '',
        start_date: today,
        end_date: today,
      },
      users: [],
      taskForm: {
        id: 0,
        user_id: '',
        description: '',
        price: '',
        total_paid: '0',
        employee_paid: '0',
        type: 'task',
        task_date: new Date().toISOString().split('T')[0],
      },
      defaultEmployeePercent: 70,
    };
  },
  computed: {
    ...mapGetters('workerTasks', ['allData', 'currentPage', 'lastPage', 'pagination', 'links']),
    currentPage() {
      return this.$store.state.workerTasks?.currentPage || 1;
    },
    lastPage() {
      return this.$store.state.workerTasks?.lastPage || 1;
    },
    data() {
      return this.allData || [];
    },
    links() {
      return this.$store.getters['workerTasks/links'] || [];
    },
    totalPendingEmployeeEarning() {
      if (!this.data || this.data.length === 0) {
        return 0;
      }
      return this.data
        .filter(task => task.status === 'pending' || task.status === 'partial')
        .reduce((total, task) => total + this.employeeBalance(task), 0);
    },
    totalPaidEmployeeEarning() {
      if (!this.data || this.data.length === 0) {
        return 0;
      }
      return this.data.reduce((total, task) => {
        return total + parseFloat(task.employee_paid ?? 0);
      }, 0);
    },
    pendingTasksCount() {
      if (!this.data || this.data.length === 0) {
        return 0;
      }
      return this.data.filter(task => task.status === 'pending').length;
    },
  },
  methods: {
    employeeEarning(task) {
      const price = parseFloat(task?.price ?? 0);
      return Math.round(price * 0.7 * 100) / 100;
    },
    employeeBalance(task) {
      return Math.max(0, this.employeeEarning(task) - parseFloat(task?.employee_paid ?? 0));
    },
    appendListFilters(params) {
      if (this.filters.user_id) {
        params.user_id = this.filters.user_id;
      }
      if (this.filters.status) {
        params.status = this.filters.status;
      }
      if (this.filters.search) {
        params.search = this.filters.search;
      }
      if (this.filters.start_date) {
        params.start_date = this.filters.start_date;
      }
      if (this.filters.end_date) {
        params.end_date = this.filters.end_date;
      }
      return params;
    },
    async fetchData(pageUrl = null) {
      const params = { per_page: 50 };
      this.appendListFilters(params);
      
      // Manejar paginación - si pageUrl es un número, usarlo como página
      if (pageUrl && typeof pageUrl === 'number') {
        params.page = pageUrl;
      } else if (pageUrl && typeof pageUrl === 'string' && pageUrl !== 'all') {
        // Si es una URL, extraer el número de página
        const pageMatch = pageUrl.match(/page=(\d+)/);
        if (pageMatch) {
          params.page = pageMatch[1];
        } else {
          // Si es solo un número como string
          const pageNum = parseInt(pageUrl);
          if (!isNaN(pageNum)) {
            params.page = pageNum;
          }
        }
      }
      
      await this.$store.dispatch('workerTasks/fetchData', params);
    },
    async fetchUsers() {
      try {
        const response = await userService.getAll({ page: 'all' });
        const allUsers = response.data.data || response.data || [];
        // Filtrar solo administradores (role === '1') y operadores (role === '6')
        this.users = allUsers.filter(user => user.role === '1' || user.role === '6');
      } catch (error) {
        console.error('Error fetching users:', error);
      }
    },
    isValidDate(date) {
      if (!date) return false;
      const parsedDate = new Date(date);
      return !isNaN(parsedDate.getTime());
    },
    openCreateModal() {
      this.taskForm = {
        id: 0,
        user_id: '',
        description: '',
        price: '',
        total_paid: '0',
        type: 'task',
        task_date: new Date().toISOString().split('T')[0],
      };
      this.showCreateModal();
    },
    initialEmployeeAmountFromPrice(price, percent = this.defaultEmployeePercent) {
      const p = parseFloat(price);
      if (!Number.isFinite(p) || p <= 0) return '';
      return String(Math.round((p * percent) / 100));
    },
    bindEmployeePayFieldsInModal() {
      const priceEl = document.getElementById('swal-price');
      const percentEl = document.getElementById('swal-employee-percent');
      const amountEl = document.getElementById('swal-employee-amount');
      if (!priceEl || !percentEl || !amountEl) return;

      let syncing = false;

      const updateAmountFromPercent = () => {
        const price = parseFloat(priceEl.value);
        const pct = parseFloat(percentEl.value);
        if (!Number.isFinite(price) || price <= 0) {
          amountEl.value = '';
          return;
        }
        const safePct = Number.isFinite(pct) ? pct : this.defaultEmployeePercent;
        amountEl.value = String(Math.round((price * safePct) / 100));
      };

      const updatePercentFromAmount = () => {
        const price = parseFloat(priceEl.value);
        const amount = parseFloat(amountEl.value);
        if (!Number.isFinite(price) || price <= 0) return;
        if (!Number.isFinite(amount) || amount < 0) return;
        percentEl.value = String(Math.round((amount / price) * 10000) / 100);
      };

      priceEl.addEventListener('input', () => {
        if (syncing) return;
        syncing = true;
        updateAmountFromPercent();
        syncing = false;
      });
      percentEl.addEventListener('input', () => {
        if (syncing) return;
        syncing = true;
        updateAmountFromPercent();
        syncing = false;
      });
      amountEl.addEventListener('input', () => {
        if (syncing) return;
        syncing = true;
        updatePercentFromAmount();
        syncing = false;
      });
    },
    showCreateModal() {
      const initialPercent = this.defaultEmployeePercent;
      const initialAmount = this.initialEmployeeAmountFromPrice(this.taskForm.price, initialPercent);

      Swal.fire({
        title: this.taskForm.id ? 'Editar Trabajo/Deuda' : 'Agregar Trabajo/Deuda',
        width: '32rem',
        html: `
          <style>
            .worker-task-modal-form .swal2-input,
            .worker-task-modal-form select.swal2-input,
            .worker-task-modal-form textarea.swal2-input {
              width: 100% !important;
              max-width: 100% !important;
              margin: 0 !important;
              display: block !important;
              box-sizing: border-box !important;
            }
          </style>
          <div class="worker-task-modal-form" style="text-align: left;">
            <label style="display: block; margin-top: 10px; font-weight: bold;">Operario *</label>
            <select id="swal-user_id" class="swal2-input">
              <option value="">Seleccione un operario</option>
              ${this.users.map(user => `<option value="${user.id}" ${this.taskForm.user_id == user.id ? 'selected' : ''}>${user.name}</option>`).join('')}
            </select>
            
            <label style="display: block; margin-top: 10px; font-weight: bold;">Descripción *</label>
            <textarea id="swal-description" class="swal2-input" placeholder="Descripción del trabajo" style="height:80px;">${this.taskForm.description}</textarea>
            
            <label style="display: block; margin-top: 10px; font-weight: bold;">Precio *</label>
            <input id="swal-price" type="number" step="1" min="0" class="swal2-input" placeholder="Precio" value="${this.taskForm.price}">

            <label style="display: block; margin-top: 10px; font-weight: bold;">% pagado al empleado</label>
            <input id="swal-employee-percent" type="number" step="1" min="0" max="100" class="swal2-input" value="${initialPercent}">

            <label style="display: block; margin-top: 10px; font-weight: bold;">Valor a pagar al empleado</label>
            <input id="swal-employee-amount" type="number" step="1" min="0" class="swal2-input" placeholder="0" value="${initialAmount}">
            
            <label style="display: block; margin-top: 10px; font-weight: bold;">Fecha</label>
            <input id="swal-task_date" type="date" class="swal2-input" value="${this.taskForm.task_date}">
          </div>
        `,
        focusConfirm: false,
        showCancelButton: true,
        confirmButtonText: 'Guardar',
        cancelButtonText: 'Cancelar',
        didOpen: () => {
          this.bindEmployeePayFieldsInModal();
        },
        preConfirm: () => {
          const user_id = document.getElementById('swal-user_id')?.value;
          const description = document.getElementById('swal-description')?.value?.trim();
          const priceInput = document.getElementById('swal-price')?.value;
          const task_date = document.getElementById('swal-task_date')?.value;
          const employeeAmountInput = document.getElementById('swal-employee-amount')?.value;

          if (!user_id || user_id === '') {
            Swal.showValidationMessage('Debe seleccionar un operario');
            return false;
          }
          if (!description || description === '') {
            Swal.showValidationMessage('La descripción es requerida');
            return false;
          }
          
          const price = parseFloat(priceInput);
          if (isNaN(price) || price <= 0) {
            Swal.showValidationMessage('El precio debe ser un número válido y positivo');
            return false;
          }

          const employeeAmount = parseFloat(employeeAmountInput);
          if (isNaN(employeeAmount) || employeeAmount < 0) {
            Swal.showValidationMessage('El valor a pagar al empleado debe ser válido');
            return false;
          }
          if (employeeAmount > price) {
            Swal.showValidationMessage('El valor al empleado no puede ser mayor al precio');
            return false;
          }

          return {
            id: this.taskForm.id || 0,
            user_id: parseInt(user_id),
            type: 'task',
            description,
            price,
            total_paid: 0,
            employee_paid: 0,
            task_date: task_date || new Date().toISOString().split('T')[0],
          };
        },
      }).then(async (result) => {
        if (result.isConfirmed && result.value) {
          try {
            const response = await this.$store.dispatch('workerTasks/save', result.value);
            if (response && response.status >= 200 && response.status < 300) {
              Swal.fire('Éxito', this.taskForm.id ? 'Trabajo/deuda actualizado correctamente' : 'Trabajo/deuda creado correctamente', 'success');
              await this.fetchData(null);
            } else {
              const errorMsg = response?.data?.message || response?.data?.error || 'Error al guardar';
              throw new Error(errorMsg);
            }
          } catch (error) {
            console.error('Error saving task:', error);
            const errorMsg = error.response?.data?.message || error.message || 'No se pudo guardar el trabajo/deuda';
            Swal.fire('Error', errorMsg, 'error');
          }
        }
      });
    },
    async markAsPaid(task) {
      if (task.status === 'paid') {
        // Si ya está pagado y se desmarca, preguntar si quiere desmarcar
        const result = await Swal.fire({
          title: '¿Desmarcar como pagado?',
          text: 'El trabajo/deuda volverá a estado pendiente',
          icon: 'question',
          showCancelButton: true,
          confirmButtonText: 'Sí, desmarcar',
          cancelButtonText: 'Cancelar',
        });

        if (result.isConfirmed) {
          try {
            const updateData = {
              id: task.id,
              status: 'pending',
              total_paid: 0,
              employee_paid: 0,
            };
            const response = await this.$store.dispatch('workerTasks/save', updateData);
            if (response && response.status >= 200 && response.status < 300) {
              Swal.fire('Éxito', 'Estado actualizado correctamente', 'success');
              await this.fetchData(null);
            } else {
              throw new Error(response?.data?.message || 'Error al actualizar');
            }
          } catch (error) {
            console.error('Error updating task:', error);
            Swal.fire('Error', 'No se pudo actualizar el estado', 'error');
            // Recargar para revertir el checkbox
            await this.fetchData(null);
          }
        } else {
          // Si cancela, recargar para mantener el estado
          await this.fetchData(null);
        }
      } else {
        // Si no está pagado y se marca, confirmar
        const result = await Swal.fire({
          title: '¿Marcar como pagado?',
          html: `
            <div style="text-align: left;">
              <p><strong>Operario:</strong> ${task.user?.name || 'N/A'}</p>
              <p><strong>Descripción:</strong> ${task.description}</p>
              <p><strong>Precio Total:</strong> ${parseFloat(task.price ?? 0).toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</p>
              <p><strong>Ganancia Empleado (70%):</strong> ${parseFloat((task.price ?? 0) * 0.7).toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</p>
            </div>
          `,
          icon: 'question',
          showCancelButton: true,
          confirmButtonText: 'Sí, marcar como pagado',
          cancelButtonText: 'Cancelar',
          confirmButtonColor: '#28a745',
        });

        if (result.isConfirmed) {
          try {
            // Al marcar como pagado, total_paid debe ser igual al precio (pago completo)
            // El backend calculará automáticamente el estado como 'paid'
            const updateData = {
              id: task.id,
              total_paid: parseFloat(task.price),
              employee_paid: this.employeeEarning(task),
            };
            const response = await this.$store.dispatch('workerTasks/save', updateData);
            if (response && response.status >= 200 && response.status < 300) {
              Swal.fire('Éxito', 'Trabajo/deuda marcado como pagado correctamente', 'success');
              await this.fetchData(null);
            } else {
              throw new Error(response?.data?.message || 'Error al actualizar');
            }
          } catch (error) {
            console.error('Error updating task:', error);
            Swal.fire('Error', 'No se pudo marcar como pagado', 'error');
            // Recargar para revertir el checkbox
            await this.fetchData(null);
          }
        } else {
          // Si cancela, recargar para mantener el estado
          await this.fetchData(null);
        }
      }
    },
    async deleteTask(id) {
      const result = await Swal.fire({
        title: '¿Está seguro?',
        text: 'Esta acción no se puede deshacer',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sí, eliminar',
        cancelButtonText: 'Cancelar',
        confirmButtonColor: '#d33',
      });

      if (result.isConfirmed) {
        try {
          await this.$store.dispatch('workerTasks/delete', id);
          Swal.fire('Éxito', 'Trabajo/deuda eliminado correctamente', 'success');
          await this.fetchData(null);
        } catch (error) {
          console.error('Error deleting task:', error);
          const errorMsg = error.response?.data?.message || error.message || 'No se pudo eliminar el trabajo/deuda';
          Swal.fire('Error', errorMsg, 'error');
        }
      }
    },
    async exportToExcel() {
      try {
        const filters = this.appendListFilters({});

        const response = await this.$store.dispatch('workerTasks/exportData', filters);
        
        // Crear un objeto URL temporal para el archivo Excel
        const url = window.URL.createObjectURL(new Blob([response.data]));
        
        // Crear un enlace temporal para descargar el archivo
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'trabajos_deudas.xlsx');
        document.body.appendChild(link);
        link.click();
        link.remove();
        
        // Limpiar el URL temporal
        window.URL.revokeObjectURL(url);
        
        Swal.fire('Éxito', 'Archivo Excel exportado correctamente', 'success');
      } catch (error) {
        console.error('Error al exportar:', error);
        Swal.fire('Error', 'No se pudo exportar el archivo Excel', 'error');
      }
    },
    async markAllPendingAsPaid() {
      const pendingTasks = this.data.filter(task => task.status === 'pending');
      
      if (pendingTasks.length === 0) {
        Swal.fire('Info', 'No hay tareas pendientes para marcar como pagadas', 'info');
        return;
      }

      const totalAmount = this.totalPendingEmployeeEarning;
      const count = pendingTasks.length;

      const result = await Swal.fire({
        title: '¿Marcar todas como pagadas?',
        html: `
          <div style="text-align: left;">
            <p><strong>Cantidad de tareas:</strong> ${count}</p>
            <p><strong>Total a pagar:</strong> ${totalAmount.toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</p>
            <p class="text-warning"><small>Se marcarán todas las tareas pendientes que están visibles en esta página.</small></p>
          </div>
        `,
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'Sí, marcar todas como pagadas',
        cancelButtonText: 'Cancelar',
        confirmButtonColor: '#28a745',
      });

      if (result.isConfirmed) {
        try {
          // Mostrar loading
          Swal.fire({
            title: 'Procesando...',
            text: 'Marcando tareas como pagadas',
            allowOutsideClick: false,
            didOpen: () => {
              Swal.showLoading();
            }
          });

          // Actualizar todas las tareas pendientes
          const updatePromises = pendingTasks.map(task => {
            const updateData = {
              id: task.id,
              total_paid: parseFloat(task.price),
              employee_paid: this.employeeEarning(task),
            };
            return this.$store.dispatch('workerTasks/save', updateData);
          });

          await Promise.all(updatePromises);

          Swal.fire('Éxito', `${count} tarea(s) marcada(s) como pagada(s) correctamente`, 'success');
          await this.fetchData(null);
        } catch (error) {
          console.error('Error updating tasks:', error);
          Swal.fire('Error', 'No se pudieron marcar todas las tareas como pagadas', 'error');
        }
      }
    },
  },
  mounted() {
    this.fetchUsers();
    this.fetchData(null);
  },
};
</script>

<style scoped>
.pagination {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}
.page-item {
  margin: 0 5px;
  cursor: pointer;
  padding: 5px 10px;
  border: 1px solid #dee2e6;
  border-radius: 4px;
}
.page-item:hover:not(.active):not(:disabled) {
  background-color: #e9ecef;
}
.page-item.active {
  background-color: #5e72e4;
  color: white;
  border-color: #5e72e4;
}
.page-item:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.cursor-pointer {
  cursor: pointer;
}
</style>
